import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const NotFound = () => {
  return (
    <div className="animate-fade-in-down max-w-4xl mx-auto text-center py-20 bg-[#090714] border border-purple-500/20 rounded-3xl p-10 shadow-2xl relative overflow-hidden my-8">
      <div className="absolute top-0 right-0 w-80 h-80 bg-purple-600/10 rounded-full blur-[140px] pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-pink-600/10 rounded-full blur-[140px] pointer-events-none" />

      <SEO
        title="404 — Node Not Found"
        description="System node disconnected. The requested page could not be found on NotKoneko's portfolio."
        noindex={true}
      />
      <div className="relative z-10 space-y-4">
        <span className="text-xs font-mono px-3 py-1 bg-purple-950/60 text-fuchsia-300 border border-purple-500/40 rounded-full inline-block">
          [ 404 // DISCONNECTED ]
        </span>
        <h1 className="text-6xl font-serif font-bold text-white tracking-wide">404</h1>
        <p className="text-lg text-gray-300 font-serif italic max-w-md mx-auto">
          — System node disconnected. The requested endpoint could not be found.
        </p>
        <div className="pt-4">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500 border border-purple-400/30 text-white font-mono text-xs font-bold rounded-xl shadow-lg shadow-purple-500/25 transition-all transform hover:scale-105"
          >
            ← Return to Core
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;

